<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-button v-on:click="goBack" variant="secondary">
          <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
        </b-button>
      </b-col>
    </b-row>
    <div class="addMode">
      <b-row>
        <b-col cols="12">
          <h1 v-if="addMode">Add Eire Index Mark</h1>
          <h1 v-if="editMode">Edit Eire Index Mark</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header">
              <strong>Eire Index Mark Details</strong>
            </div>
            <div class="form-container">
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="eireIndexMarkCode">Code<span class="mandatory">*</span></label>
                    <b-form-input v-model="newEireIndexMark.code" type="text" id="eireIndexMarkCode"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="eireIndexMarkCounty">County<span class="mandatory">*</span></label>
                    <b-form-input v-model="newEireIndexMark.county" type="text" id="eireIndexMarkCounty"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="eireIndexMarkIrishName">Irish Name<span class="mandatory">*</span></label>
                    <b-form-input v-model="newEireIndexMark.irish_name" type="text" id="eireIndexMarkIrishName"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="eireIndexMarkLocalAuthority">Local Authority</label>
                    <b-form-input v-model="newEireIndexMark.local_authority" type="text" id="eireIndexMarkLocalAuthority"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr/>
              <b-row>
                <b-col cols="12" sm="12" md="12">
                  <p>
                    <b-button v-on:click="saveEireIndexMark" variant="primary" :disabled="!allowSave">
                      <i class="fa fa-check"></i>&nbsp;Save Eire Index Mark
                    </b-button>
                  </p>
                  <b-alert v-if="saveError" variant="danger" show><strong>Error saving data. Please try again.</strong></b-alert>
                  <b-alert v-if="saveInProgress" variant="info" show><strong>Saving data. Please wait...</strong></b-alert>
                  <b-alert v-if="saveSuccess" variant="success" show><strong>Data saved successfully.</strong></b-alert>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

  import LoadingSpinner from '../../../components/loadingSpinner/LoadingSpinner'

  const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
      let user = JSON.parse(localStorage.getItem('user'))
      if (user != null) {
        resolve(user)
      } else {
        reject()
      }
    })
  }

  export default {
    name: 'eire-index-mark-form',
    props: ['eireIndexMark', 'mode'],
    components: {
      LoadingSpinner: LoadingSpinner,
    },
    data () {
      return {
        userAuthLevel: '',
        addMode: false,
        editMode: false,
        saveError: false,
        saveInProgress: false,
        deleteSuccess: false,
        saveSuccess: false,
        eireIndexMarkObj: {},
        show: true,
        newEireIndexMark: this.resetEireIndexMark(),
      }
    },
    created () {

      this.$data.newEireIndexMark = this.$props['eireIndexMark'];
      console.log(this.$props['eireIndexMark']);
      this.$data.addMode = true;

      if (this.$props['mode'] === 'edit') {
        this.$data.editMode = true;
        this.$data.addMode = false;
      }

      if (this.$props['mode'] === 'add') {
        this.$data.addMode = true;
        this.$data.editMode = false;
        this.$data.newEireIndexMark = this.resetEireIndexMark();
      }

      // populate the dropdown controls
      getCurrentUser()
        .then((userDetails) => {
          this.$data.userAuthLevel = userDetails.auth;
        })
        .catch((err) => { 
          console.error(err)
        })
    },
    computed: {
      isUserSuperAdmin() {
        if (this.$data.userAuthLevel == 'Super Admin') {
            return true;
        }
        else {
            return false;
        }
      },
      isMinimumSuperAdmin() {
        let returnVal = false;
        switch (this.$data.userAuthLevel) {
          case 'Super Admin':
            returnVal = true;
            break;
          default:
            returnVal = false;
        }
        
        return returnVal;
      },
      isMinimumCompanyUser() {
        let returnVal = false;
        switch (this.$data.userAuthLevel) {
          case 'Super Admin':
          case 'Company Users':
            returnVal = true;
            break;
          default:
            returnVal = false;
        }
        return returnVal;
      },
      isMinimumAreaUser() {
        let returnVal = false;
        switch (this.$data.userAuthLevel) {
          case 'Super Admin':
          case 'Company Users':
          case 'Area Users':
            returnVal = true;
            break;
          default:
            returnVal = false;
        }
        console.log('Area: ', returnVal);
        return returnVal;
      },
      isMinimumSiteUser() {
        let returnVal = false;
        switch (this.$data.userAuthLevel) {
          case 'Super Admin':
          case 'Company Users':
          case 'Area Users':
          case 'Site Users':
            returnVal = true;
            break;
          default:
            returnVal = false;
        }
        
        return returnVal;
      },
      isUserReadOnly () {
        return this.isReadOnly(this.$data)
      },
      allowSave: function () {

        let allowSaveFlag = true

        if (this.$data.newEireIndexMark.code === '') {
          allowSaveFlag = false
        }

        return allowSaveFlag
      }
    },
    methods: {
        goBack: function() {
            this.$data.fontsLoaded = false;
            this.$data.newEireIndexMark = this.resetEireIndexMark();
            this.$parent.closeEireIndexMarkForm();
        },
        isReadOnly (user) {
            return (user.userAuthLevel === 'Read Only');
        },
        resetEireIndexMark() {
          return {
            id: 0,
            code: '',
            county: '',
            irish_name: '',
            local_authority: ''
          }
        },
        getHTTPHeaders () {
          let user = JSON.parse(localStorage.getItem('user'))
          return {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              'Authorization':  'Bearer ' + user.token,
            }
          }
        },
        clearAlerts () {
            this.$data.saveError = false;
            this.$data.saveInProgress = false;
        },
        saveEireIndexMark() {
            this.clearAlerts();
            this.$data.saveInProgress = true;
            let headersObj = this.getHTTPHeaders();

            let url = 'eireindexmark';
            let method = 'post';
            let dataPostObject = {
              code: this.$data.newEireIndexMark.code,
              county: this.$data.newEireIndexMark.county,
              irish_name: this.$data.newEireIndexMark.irish_name,
              local_authority: this.$data.newEireIndexMark.local_authority,
            }
            
            if(typeof this.$data.newEireIndexMark.id !== undefined && this.$data.newEireIndexMark.id > 0) {
              url = 'eireindexmark/'+this.$data.newEireIndexMark.id;
              method='put';
              dataPostObject.id = this.$data.newEireIndexMark.id;
            }

            this.$http[method](url, dataPostObject, headersObj)
            .then((response) => {
                console.log(response.data);
                if (response.data.success == true) {
                    this.$data.saveInProgress = false;
                    this.$data.saveError = false;
                    this.$data.saveSuccess = true;
                    this.$parent.closeEireIndexMarkForm();
                }
                else {
                    // data error
                    this.$data.saveInProgress = false;
                    this.$data.saveError = true;
                }
            })
            .catch ((err) => {
                console.error(err);
                this.$data.saveInProgress = false;
                this.$data.saveError = true;
            });
        },
    }
  }
</script>